import { MESSAGE_ID_DESCRIPTION, messageIdFromString } from './chatItem';
import type { MessageId } from './types';

export interface FeedParseError {
  readonly path: string;
  readonly message: string;
}

export type FeedParseResult<T> = { readonly ok: true; readonly value: T } | { readonly ok: false; readonly error: FeedParseError };

/** Parses and brands a durable message id without accepting malformed wire values. */
export function parseMessageId(value: unknown, path = '$'): FeedParseResult<MessageId> {
  if (typeof value !== 'string') return expected(path, 'string', value);

  const messageId = messageIdFromString(value);
  if (!messageId) return expected(path, MESSAGE_ID_DESCRIPTION, value);
  return { ok: true, value: messageId };
}

function expected(path: string, expectedType: string, value: unknown): FeedParseResult<never> {
  return {
    ok: false,
    error: {
      path,
      message: `expected ${expectedType}, received ${describeValue(value)}`,
    },
  };
}

function describeValue(value: unknown): string {
  if (value === null) return 'null';
  if (Array.isArray(value)) return 'array';
  return typeof value;
}
